import * as React from 'react'
import GameBoardModel from '../models/GameBoard'
import Chance from '../utils/Chance'
import Card from './Card'
import Deck from './Deck'
import Game from './Game'
import Hero from './Hero'

interface IGameBoardProps {
  model: GameBoardModel
}

export default class GameBoard extends React.Component<IGameBoardProps> {
  constructor(props: IGameBoardProps) {
    super(props)
  }

  renderCards() {
    return Array.from(this.props.model.cards)
      .map(([point, card]) => <Card key={card.id} model={card}/>)
  }

  renderDecks() {
    return Array.from(this.props.model.decks)
      .map(([point, deck]) => <Deck key={deck.id} model={deck}/>)
  }

  renderHero() {
    return <Hero model={this.props.model.hero} />
  }

  getRules() {
    return `
1. Swipe left/right/up/down to make the hero move in any direction. You can also use the arrow keys on the keyboard to control the hero.
2. There are three kinds of cards: Monsters, Potions and Spells. When you pick a monster, your health is reduced by the value of the monster. If you pick a potion, your health increases by the value of the potion.
3. If you pick a spell, a spell gets added to your collection. A spell allows you to control a monster. To use a spell, tap on a spell in your collection to select it, and then tap on the monster.
4. When you move, all controlled monsters will also move in the same direction after you.
5. Whenever you kill a monster, it gets stacked up and the game board rises. Your objective is to make the game board rise enough to reach the exit door, which is on a high platform.
6. If your health drops to zero, you lose!
`
  }

  rotateBoard() {
    this.props.model.rotate()
    Game.refresh()
  }

  render() {
    return (
      <div className='game-board'>
        <div className='master-stats'>
          <div className='text-center'>
            Floor: {this.props.model.game.currentBoardIndex + 1} |
            Gold: {this.props.model.hero.gold} |&nbsp;
            <a href='#' onClick={(e) => {
              e.preventDefault()
              alert(this.getRules())
            }}>Rules</a> |&nbsp;
            <a href='#' onClick={(e) => {
              e.preventDefault()
              this.rotateBoard()
            }}>Rotate</a> |&nbsp;
            <a href={`#/game/4/4/${Chance.upto(999999)}`}
              onClick={() => setTimeout(() => window.location.reload())}>New Game</a>
          </div>
          <br/>
          <hr/>
        </div>
        <div className='board-container'>
          <div className='absolute full-width'>
            { this.renderDecks() }
            { this.renderCards() }
          </div>
        </div>
        { this.renderHero() }
      </div>
    )
  }
}
